import React from 'react'
import { ApolloProvider } from '@apollo/react-hooks'
import { ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client'
import { setContext } from '@apollo/client/link/context'
import { ToastContainer } from 'react-toastify'
import CssBaseline from '@mui/material/CssBaseline'
import { ThemeProvider } from '@mui/material/styles'

import './App.css'

import theme from './theme'
import AuthProvider from './hooks/useAuthentication'
import Router from './router/router'

const getApiUrl = () => {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL
  }
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname
    if (hostname === 'vhs.ahmadiyya.se') {
      return 'https://5g11az8yk2.execute-api.eu-north-1.amazonaws.com/graphql'
    }
    if (hostname === 'vhs.staging.ahmadiyya.se') {
      return 'https://j75m16h2p7.execute-api.eu-north-1.amazonaws.com/graphql'
    }
  }
  // fallback default
  return 'http://localhost:4000/graphql'
}

const httpLink = createHttpLink({
  uri: getApiUrl(),
})

const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem('jwtToken')

  return {
    headers: {
      ...headers,
      authorization: token || '',
    },
  }
})

const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
})

const App = () => {
  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      <ApolloProvider client={client}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <AuthProvider>
            <Router />
          </AuthProvider>
        </ThemeProvider>
      </ApolloProvider>
    </>
  )
}

export default App
